import React, { useState, useEffect } from 'react';
import axios from 'axios';
import authHeader from '../services/AuthHeader';
import { Grid, Row, Col } from 'react-bootstrap';

const ViewStatement = (props) => {
  const [image, setImage] = useState();
  const [isLoading, setLoading] = useState(true);
  const CandidateHeading = props.headingLevel || 'h1';
  const StatementHeading = props.statementHeadingLevel || 'h2';
  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_BASE + 'candidateprofile/' + props.StarId,
        { headers: authHeader() }
      )
      .then((res) => {
        setImage(res.data);
        setLoading(false);
      });
  }, []);

  if (isLoading) {
    return <div className='App'>Loading...</div>;
  }

  return (
    <>
      <Grid>
        <Row>
          <Col>
            <img
              className='center-preview'
              style={{
                display: 'block',
                marginLeft: 'auto',
                marginRight: 'auto',
                width: '50%',
                paddingBottom: '50px',
              }}
              src={
                image.imageFileName !== ''
                  ? process.env.REACT_APP_API_BASE +
                    'imageview/' +
                    image.candidateId +
                    '_' +
                    image.imageFileName
                  : 'no-picture-available-icon.jpg'
              }
              alt={`Candidate portrait for ${image.candidateFirstName} ${image.candidateLastName}`}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <div style={{ textAlign: 'center' }}>
              <CandidateHeading className='h3'>
                {image.candidateFirstName} {image.candidateLastName}
              </CandidateHeading>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div style={{ marginTop: '20px' }}>
              <StatementHeading className='h5'>Candidate Statement</StatementHeading>
            </div>
          </Col>
        </Row>
        <Row>
          <Col style={{ marginRight: '15px' }}>
            {image.candidateStatement !== ''
              ? image.candidateStatement
              : 'Not Available'}
          </Col>
        </Row>
      </Grid>
    </>
  );
};

export default ViewStatement;
